import BalanceInterface from "@/interfaces/Balance.interface";
import api from "../config";

export class BalanceRest{
    getAllBalance(params: any): Promise<any> {
        return api.get('/balance', { params }).then((response) => response.data);
    }

    getBalanceByUser(): Promise<any> {
        return api.get('/balance/user').then((response) => response.data);
    }
}